import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import statusQueries from '../../queries/statusQueries'
import Empty from '../../components/Empty'
import moment from 'moment'
import StatusType from '../../components/StatusType'
import useCurrentMonth from '../../utils/useCurrentMonth'
import { useSelector } from 'react-redux'

const StatusHistory = () => {

    const { start, end } = useCurrentMonth();

    const user = useSelector((state) => state.user.user);

    const [result, setResult] = useState([])
    const [from, setFrom] = useState(start)
    const [to, setTo] = useState(end)

    const getData = statusQueries.useStatusHistoryQueries(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }
        }
    )

    useEffect(() => {
        getData.mutateAsync({id: user?.id, from: from, to: to})
    }, [from, to]);
    
  return (
    <div className='card-shadow m-4 max-[768px]:m-2 bg-white rounded-[10px]'>

        <div className='flex justify-between max-[934px]:flex-col items-center p-6 gap-y-3'>
            <div>
                <p className='text-[13px] text-[#6D6B77] font-medium'>Status History</p>
            </div>
            <div className='flex gap-2 max-[799px]:flex-col max-[799px]:w-full'>
                <div className='flex flex-col'>
                    <label className='text-[13px] text-[#6D6B77] font-medium'>From Date</label>
                    <input value={from} onChange={(e)=>{setFrom(e.target.value)}} type="date" placeholder='Type to search...' className='w-[230px] max-[799px]:w-full h-[40px] border rounded-[7px] pl-4 pr-3 mt-[1px] text-[13px]' />
                </div>
                <div className='flex flex-col'>
                    <label className='text-[13px] text-[#6D6B77] font-medium'>To Date</label>
                    <input value={to} onChange={(e)=>{setTo(e.target.value)}} type="date" placeholder='Type to search...' className='w-[230px] max-[799px]:w-full h-[40px] border rounded-[7px] pl-4 pr-3 mt-[1px] text-[13px]' />
                </div>
            </div>
        </div>

        {
            getData?.isLoading ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div className='px-6 pb-6'>
                <div>
                    {
                        result?.length > 0 ?
                            <table className='table w-full'>
                                <thead>
                                    <tr className='table-row'>
                                        <th width="70px">Sl No.</th>
                                        <th width="160px">Date</th>
                                        <th>Work Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result?.map((row, index) => {
                                        const status = StatusType?.find(element => element?.value === row?.work_status)
                                        return(
                                            <tr key={index} className='table-row'>
                                                <td>{index+1}</td>
                                                <td className='py-3'>{moment(row?.date).format("DD-MM-YYYY")}</td>
                                                <td>{status?.label}</td>
                                            </tr>
                                        )}
                                    )}
                                </tbody>
                            </table>:
                        <Empty />
                    }
                </div>
            </div>
        }

    </div>
  )
}

export default StatusHistory
